import third_st from "../assets/photos/project/third_st.jpg"
import eleventh_st from "../assets/photos/project/eleventh_st.jpeg"
import chinese_heratige_building from "../assets/photos/project/chinese_heratige_building.jpg"
import evergreen_village_square from "../assets/photos/project/evergreen_village_square.jpg"
import five_wounds_church_1 from "../assets/photos/project/five_wounds_church-1.jpg"
import five_wounds_church_2 from "../assets/photos/project/five_wounds_church_2.jpg"
import govenors_mansion from "../assets/photos/project/govenors_mansion.jpeg"
import hayes_mansion_1 from "../assets/photos/project/hayes_mansion_1.jpeg"
import hayes_mansion_2 from "../assets/photos/project/hayes_mansion_2.jpeg"
import hensley_residence from "../assets/photos/project/hensley_residence.jpg"
import hotel_de_anza from "../assets/photos/project/hotel_de_anza.jpg"
import kelly_park_printing_office from "../assets/photos/project/kelly_park_printing_office.jpg"
import mekong_realty from "../assets/photos/project/mekong_realty.jpeg"
import mission_san_jose from "../assets/photos/project/mission_san_jose.jpg"
import peralta_house from "../assets/photos/project/peralta_house.jpeg"
import portugese_historical_museum from "../assets/photos/project/portugese_historical_museum.jpeg"
import saint_josef_1 from "../assets/photos/project/saint_josef_1.jpeg"
import saint_josef_2 from "../assets/photos/project/saint_josef_2.jpg"
import san_jose_moa from "../assets/photos/project/san_jose_moa.jpeg"
import santa_clara_mission from "../assets/photos/project/santa_clara_mission.jpg"
import sju_tower from "../assets/photos/project/sju_tower.jpeg"
import st_anthony_church from "../assets/photos/project/st_anthony_church.jpeg"
import thomas_fallen_house from "../assets/photos/project/thomas_fallen_house.jpg"
import viet_museum from "../assets/photos/project/viet_museum.jpg"
import winchester_1 from "../assets/photos/project/winchester_1.jpg"
import winchester_2 from "../assets/photos/project/winchester_2.jpg"
import winchester_3 from "../assets/photos/project/winchester_3.jpg"
import winchester_4 from "../assets/photos/project/winchester_4.jpg"
import winchester_5 from "../assets/photos/project/winchester_5.jpg"
import government_center from "../assets/photos/project/government_center.jpg"

import alice_nakamura from "../assets/photos/team/nakamura.jpeg"
import bob_chen from "../assets/photos/team/chen.jpeg"
import charlie_singh from "../assets/photos/team/singh.jpeg"
import dana_alFarsi from "../assets/photos/team/al_Farsi.jpeg"
import ethan_osei from "../assets/photos/team/osei.jpeg"
import fiona_youssef from "../assets/photos/team/youssef.jpeg"
import george_nwosu from "../assets/photos/team/nwosu.jpeg"
import henry_takahhashi from "../assets/photos/team/takahashi.jpeg"
import isaac_ramos from "../assets/photos/team/ramos.jpeg"
import jack_idris from "../assets/photos/team/idris.jpeg"
import kevin_das from "../assets/photos/team/das.jpeg"
import lena_haddad from "../assets/photos/team/haddad.jpeg"
import miles_zhou from "../assets/photos/team/zhou.jpeg"
import nina_patel from "../assets/photos/team/patel.jpeg"
import oscar_kimani from "../assets/photos/team/kimani.jpeg"

import workshop from '../assets/photos/about/workshop.jpeg'
import founders from '../assets/photos/about/founders.jpeg'
import contact from '../assets/photos/about/contact.jpeg'

import bathroom_remodel from '../assets/photos/services/bathroom_remodel.jpg'
import full_home_remodel from '../assets/photos/services/full_home_remodel.jpg'
import interior_renovation from '../assets/photos/services/interior_rennovation.jpg'
import exterior_renovation from '../assets/photos/services/exterior_renovation.jpg'
import open_floor_plan_conversion from '../assets/photos/services/open_floor_plan_conversion.jpg'
import room_additions from '../assets/photos/services/room_additions.jpg'
import deck_construction from '../assets/photos/services/deck_construction.jpg'
import patio_rebuild from '../assets/photos/services/patio_rebuild.jpg'
import adu_development from '../assets/photos/services/adu_development.jpg'
import re_roofing from '../assets/photos/services/re_roofing.jpg'
import stucco_and_brick_veneer_siding from '../assets/photos/services/stucco_and_brick_veneer_siding.jpg'
import historic_window_and_door_replacement from '../assets/photos/services/historic_window_and_door_replacement.jpg'
import structural_upgrades from '../assets/photos/services/structural_upgrades.jpg'
import wall_upgrade from '../assets/photos/services/wall_upgrades.jpg'
import foundation_upgrade from '../assets/photos/services/foundation_upgrades.jpg'
import chimney_upgrade from '../assets/photos/services/chimney_upgrade.jpg'
import stair_replacement_and_redesign from '../assets/photos/services/stair_replacement_and_redesign.jpg'
import new_trellis_and_outdoor_enhancements from '../assets/photos/services/new_trellis_and_outdoor_enhancements.jpg'
import electrical_panel_upgrade from '../assets/photos/services/electrical_panel_upgrade.jpg'
import gfci_switch_replacement from '../assets/photos/services/gfci_switch_replacement.jpg'
import hvac_installation_furnace from '../assets/photos/services/hvac_installation_furnace.jpeg'
import hvac_installation_ac_unit from '../assets/photos/services/hvac_installation_ac_unit.jpg'
import plumbing_upgrades from '../assets/photos/services/plumbing_upgrades.jpg'
import violation_corrections from '../assets/photos/services/violation_corrections.jpg'

export const landscape_dic = {
    '11th Street Home' : eleventh_st,
    'Evergreen Village Square' : evergreen_village_square,
    'California Govenors Mansion' : govenors_mansion,
    'Hayes Mansion' : hayes_mansion_2,
    'Peralta House' : peralta_house,
    'st Josef Cathedral' : saint_josef_1,
    'San Jose Museum of Art' : san_jose_moa,
    'Thomas Fallen House' : thomas_fallen_house
}
export const portrait_dic = {
    'Chinese Heritage Building' : chinese_heratige_building,
    'Church of Five Wounds' : five_wounds_church_1,
    'San Jose Government Center' : government_center,
    'Hensley Residence': hensley_residence,
    'Hotel DeAnza': hotel_de_anza,
    'Mekong Realty': mekong_realty,
    'SJU Tower':sju_tower,
    'st Anthonys Church': st_anthony_church
}

export const project_photo_dic = {
    chinese_heratige_building: [
        { img: chinese_heratige_building, cap: "Chinese Heritage Building" }
    ],
    eleventh_st: [
        { img: eleventh_st, cap: "Eleventh Street" }
    ],
    evergreen_village_square: [
        { img: evergreen_village_square, cap: "Evergreen Village Square" }
    ],
    five_wounds_church: [
        { img: five_wounds_church_1, cap: "Five Wounds Church - Exterior" },
        { img: five_wounds_church_2, cap: "Five Wounds Church - Interior" }
    ],
    govenors_mansion: [
        { img: govenors_mansion, cap: "Governor's Mansion" }
    ],
    san_jose_government_center: [
        { img: government_center, cap: "Government Center" }
    ],
    hayes_mansion: [
        { img: hayes_mansion_1, cap: "Hayes Mansion - Entry" },
        { img: hayes_mansion_2, cap: "Hayes Mansion - Garden View" }
    ],
    hensley_residence: [
        { img: hensley_residence, cap: "Hensley Residence" }
    ],
    hotel_de_anza: [
        { img: hotel_de_anza, cap: "Hotel De Anza" }
    ],
    kelly_park_printing_office: [
        { img: kelly_park_printing_office, cap: "Kelly Park Printing Office" }
    ],
    mekong_realty: [
        { img: mekong_realty, cap: "Mekong Realty" }
    ],
    mission_san_jose: [
        { img: mission_san_jose, cap: "Mission San José" }
    ],
    peralta_house: [
        { img: peralta_house, cap: "Peralta House" }
    ],
    portugese_historical_museum: [
        { img: portugese_historical_museum, cap: "Portuguese Historical Museum" }
    ],
    saint_josef_church: [
        { img: saint_josef_1, cap: "Saint Josef Church - Exterior" },
        { img: saint_josef_2, cap: "Saint Josef Church - Interior" }
    ],
    san_jose_moa: [
        { img: san_jose_moa, cap: "San José Museum of Art" }
    ],
    santa_clara_mission: [
        { img: santa_clara_mission, cap: "Santa Clara Mission" }
    ],
    sju_tower: [
        { img: sju_tower, cap: "SJU Tower" }
    ],
    st_anthony_church: [
        { img: st_anthony_church, cap: "St. Anthony Church" }
    ],
    third_st_home: [
        { img: third_st, cap: "Third Street Home" }
    ],
    thomas_fallen_house: [
        { img: thomas_fallen_house, cap: "Thomas Fallen House" }
    ],
    viet_museum: [
        { img: viet_museum, cap: "Vietnamese Museum" }
    ],
    winchester: [
        { img: winchester_1, cap: "Winchester - Roof" },
        { img: winchester_2, cap: "Winchester - Driveway" },
        { img: winchester_3, cap: "Winchester - Basement" },
        { img: winchester_4, cap: "Winchester - Sitting Room" },
        { img: winchester_5, cap: "Winchester - Unfinished Wing" }
    ]
};

 

export const team_photo_dic = {
    alice_nakamura: { img: alice_nakamura, cap: 'Alice' },
    bob_chen: { img: bob_chen, cap: 'Bob' },
    charlie_singh: { img: charlie_singh, cap: 'Charlie' },
    dana_alFarsi: { img: dana_alFarsi, cap: 'Dana' },
    ethan_osei: { img: ethan_osei, cap: 'Ethan' },
    fiona_youssef: { img: fiona_youssef, cap: 'Fiona' },
    george_nwosu: { img: george_nwosu, cap: 'George' },
    henry_takahhashi: { img: henry_takahhashi, cap: 'Henry' },
    isaac_ramos: { img: isaac_ramos, cap: 'Isaac' },
    jack_idris: { img: jack_idris, cap: 'Jack' },
    kevin_das: { img: kevin_das, cap: 'Kevin' },
    lena_haddad: { img: lena_haddad, cap: 'Lena' },
    miles_zhou: { img: miles_zhou, cap: 'Miles' },
    nina_patel: { img: nina_patel, cap: 'Nina' },
    oscar_kimani: { img: oscar_kimani, cap: 'Oscar' },
}

export const about_photo_dic = {
    workshop :{img: workshop, cap: 'workshop'},
    founders : {img: founders, cap: 'founders'},
    contact: {img:contact, cap: 'contact'}

}

export const service_photo_dic = {
    bathroom_remodel: { img: bathroom_remodel, cap: "bathroom remodel" },
    full_home_remodel: { img: full_home_remodel, cap: "full home remodel" },
    interior_renovation: { img: interior_renovation, cap: "interior renovation" },
    exterior_renovation: { img: exterior_renovation, cap: "exterior renovation" },
    open_floor_plan_conversion: { img: open_floor_plan_conversion, cap: "open floor plan conversion" },
    room_additions: { img: room_additions, cap: "room additions" },
    deck_construction: { img: deck_construction, cap: "deck construction" },
    patio_rebuild: { img: patio_rebuild, cap: "patio rebuild" },
    adu_development: { img: adu_development, cap: "adu development" },
    re_roofing: { img: re_roofing, cap: "re-roofing" },
    stucco_and_brick_veneer_siding: { img: stucco_and_brick_veneer_siding, cap: "stucco and brick veneer siding" },
    historic_windows_and_doors: { img: historic_window_and_door_replacement, cap: "historic window and door replacement" },
    structural_upgrades: { img: structural_upgrades, cap: "structural upgrades" },
    wall_upgrade: { img: wall_upgrade, cap: "wall upgrade" },
    foundation_upgrade: { img: foundation_upgrade, cap: "foundation upgrade" },
    chimney_upgrade: { img: chimney_upgrade, cap: "chimney upgrade" },
    stair_replacement_and_redesign: { img: stair_replacement_and_redesign, cap: "stair replacement and redesign" },
    outdoor_enhancements: { img: new_trellis_and_outdoor_enhancements, cap: "new trellis and outdoor enhancements" },
    electrical_panel_upgrade: { img: electrical_panel_upgrade, cap: "electrical panel upgrade" },
    gfci_switch_replacement: { img: gfci_switch_replacement, cap: "GFCI switch replacement" },
    furnace_installation: { img: hvac_installation_furnace, cap: "HVAC installation (furnace)" },
    ac_installation: { img: hvac_installation_ac_unit, cap: "HVAC installation (AC unit)" },
    plumbing_upgrades: { img: plumbing_upgrades, cap: "plumbing upgrades" },
    violation_corrections: { img: violation_corrections, cap: "violation corrections" }
};
